import React from 'react';
import ContentTab from '../ContentTab/ContentTab';

export const BrandsTab = ({ handleTabClick, query, items, id, country }) => {

  const showContentRowUI = country !== 'CA';

  return (
    <ContentTab
      handleTabClick={handleTabClick}
      query={query}
      id={id}
      items={items}
      newContentRowUI={showContentRowUI}
    />
  )
}

export default BrandsTab
